<template>
    <div class="admin-requests-wrapper">
        <Tabs class="pt-tabs" name="composer" :value="selectedTab" :animated="false">
            <TabPane label="Leave Requests" name="plan" tab="composer">
                <LeaveRequest selected-type="leave" />
            </TabPane>
            <TabPane label="Leave Credits" name="wrapup" tab="composer">
                <LeaveCredit />
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
import LeaveRequest from '@/components/Requests/Admin/Leave/LeaveRequest/index.vue';
import LeaveCredit from '@/components/Requests/Admin/Leave/LeaveCredit/index.vue';

export default {
    components: { LeaveRequest, LeaveCredit },
    data() {
        return {
            isLoading: false,
            requestList: [],
            type: null,
            selectedStatus: this.$route.query.status,
            selectedType: null,
            selectedDates: null,
            selectedUser: this.$route.query.user,
            currentPage: 1,
            totalCount: null,
            isFilterClick: false,
            totalPerPage: 10,
            totalPages: 1,
            limit: 10,
            employeeList: [],
        };
    },
};
</script>
<style lang="scss">
.admin-requests-wrapper {
    .ivu-col {
        button {
            border-radius: 15px;
        }
    }
    .title-wrapper {
        display: block;

        .ivu-col {
            max-width: 100% !important;
        }
        .text-right {
            text-align: left;
            padding-top: 0 !important;
        }
    }
}
</style>
